/** @jsxImportSource @emotion/react */
import React, { useEffect } from 'react';
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import { ModalMultiSelectField, SelectItem } from '../../../shared/ModalMultiSelectField';
import { useAppDispatch } from '../../../core/store';
import { fetchRegions, selectIsFetching, selectRegions } from '../store/assessmentReportResultsSlice';
import { AssessmentReportFilters } from '../model/assessmentReportQueryParams';

interface RegionMultiSelectFieldProps {
  filters: AssessmentReportFilters;
  defaultValue?: string[];
  editable?: boolean;
  onUpdate?: (brand: string[]) => void;
}

export function RegionMultiSelectField({
  filters,
  defaultValue = [],
  editable = false,
  onUpdate,
}: RegionMultiSelectFieldProps) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (editable) {
      dispatch(fetchRegions(filters));
    }
  }, [dispatch, editable, filters]);

  const regions = useSelector(selectRegions);
  const isFetching = useSelector(selectIsFetching);

  const toSelectItem = (item: string): SelectItem => {
    return {
      code: item,
      description: item,
    };
  };

  const toString = (item: SelectItem): string => {
    return item.code;
  };

  return (
    <ModalMultiSelectField
      icon='world'
      defaultValue={defaultValue != null ? defaultValue.map(v => toSelectItem(v)) : []}
      loading={isFetching}
      list={regions.map((b): SelectItem => toSelectItem(b) as SelectItem)}
      title={t('assessment.report.filters.regions') || ''}
      editable={editable}
      onUpdateValue={(selectedBrand: SelectItem[]) => {
        if (onUpdate) {
          onUpdate(selectedBrand.map(i => toString(i)));
        }
      }}
    />
  );
}
